<!-- 工作台 -->
<template>
  <div v-loading="loading">
    <div class="form-main">
      <el-form :model="formData" ref="formData" label-width="120px">
        <el-form-item label="企业名称" prop="Name">
          <el-input v-model="formData.Name" disabled></el-input>
        </el-form-item>
        <el-form-item label="简称" prop="Abbr">
          <el-input v-model="formData.Abbr" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="Contactor">
          <el-input v-model="formData.Contactor" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="PhoneNum">
          <el-input v-model="formData.PhoneNum" disabled></el-input>
        </el-form-item>
        <el-form-item label="主要经营车型" prop="MainVehicle">
          <el-input v-model="formData.MainVehicle" disabled></el-input>
        </el-form-item>
        <el-form-item label="主要经营配件" prop="MainPartName">
          <el-input v-model="formData.MainPartName" disabled></el-input>
        </el-form-item>
        <el-form-item label="官网" prop="Website">
          <el-input v-model="formData.Website" disabled></el-input>
        </el-form-item>
        <el-form-item label="QQ" prop="Qq">
          <el-input v-model="formData.Qq" disabled></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="Email">
          <el-input v-model="formData.Email" disabled></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["entpId"],
  components: {},
  name: "",
  data() {
    return {
      formData: {
        Abbr: "",
        Name: "",
        Email: "",
        PhoneNum: "",
        MainPartName: "",
        MainVehicle: "",
        Qq: "",
        Contactor: "",
        Website: "",
        Id: "",
      },
      loading: false,
    };
  },
  mounted() {
    this.getEntpInfoes();
  },
  methods: {
    getEntpInfoes() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpUnions/GetEnterpriseData",
          data: {
            ReleEntpId: this.entpId,
          },
        })
        .then((res) => {
          this.formData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="less" scoped>
</style>
